import React from 'react'
import { Handle, Position } from '@xyflow/react';
import "./CustomNode.scss"

function CustomNode({ data }) {
  return (
    <div>
        <button onClick={data.onClick} className='btnAddCustom btn btn-sm btn-primary rounded-pill px-3 fw-medium'>{data.label}</button>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
  )
}

export default CustomNode